import {
  api,
  CreateOdpAssessmentRequest,
  OdpAssessmentDetailsResult,
  PagedResultOfOdpAssessmentListResult,
  UpdateOdpAssessmentRequest,
} from 'api';
import { rtkQueryApi } from 'store/rtkQueryApi';

const odpAssessmentApi = rtkQueryApi.injectEndpoints({
  endpoints: (builder) => ({
    odpAssessmentList: builder.query<
      PagedResultOfOdpAssessmentListResult,
      { examinerId: number; pageIndex: number; pageSize: number }
    >({
      query: ({ examinerId, pageIndex, pageSize }) => {
        return api.odpAssessment.getAll({ examinerId, page: pageIndex + 1, pageSize });
      },
      providesTags: ['OdpAssessment'],
    }),
    odpAssessment: builder.query<OdpAssessmentDetailsResult, { examinerId: number; id: number }>({
      query: ({ examinerId, id }) => {
        return api.odpAssessment.get({ examinerId, id });
      },
      providesTags: ['OdpAssessment'],
    }),

    createOdpAssessment: builder.mutation<
      OdpAssessmentDetailsResult,
      { examinerId: number; odpAssessment: CreateOdpAssessmentRequest }
    >({
      query: ({ examinerId, odpAssessment }) => {
        return api.odpAssessment.create({ examinerId }, odpAssessment);
      },
      invalidatesTags: ['OdpAssessment', 'HasCompletedOdpAssessment', 'ExaminerStatus'],
    }),

    updateOdpAssessment: builder.mutation<
      OdpAssessmentDetailsResult,
      { examinerId: number; id: number; odpAssessment: UpdateOdpAssessmentRequest }
    >({
      query: ({ examinerId, id, odpAssessment }) => {
        return api.odpAssessment.update({ examinerId, id }, odpAssessment);
      },
      invalidatesTags: ['OdpAssessment', 'HasCompletedOdpAssessment', 'ExaminerStatus'],
    }),

    deleteOdpAssessment: builder.mutation<void, { examinerId: number; id: number }>({
      query: ({ examinerId, id }) => {
        return api.odpAssessment.delete({ examinerId, id });
      },
      invalidatesTags: ['OdpAssessment', 'HasCompletedOdpAssessment', 'ExaminerStatus'],
    }),
    hasCompletedOdpAssessment: builder.query<boolean, number>({
      query: (examinerId) => {
        return api.odpAssessment.hasCompleted({ examinerId });
      },
      providesTags: ['HasCompletedOdpAssessment'],
    }),
  }),
});

export const {
  useOdpAssessmentListQuery,
  useOdpAssessmentQuery,
  useCreateOdpAssessmentMutation,
  useUpdateOdpAssessmentMutation,
  useDeleteOdpAssessmentMutation,
  useHasCompletedOdpAssessmentQuery,
} = odpAssessmentApi;
